/*
 * This file is updated with actual values during CI build.
 * Values are injected by `build-scripts/inject-ci-config.ts`
 *
 * ! Moving this file to a different location will break the CI build.
 *   Update `build-scripts/inject-ci-config.ts` with new path if needed.
 */

export const ciBuildConfig = { CI_FINGERPRINT: 'default-value' };
